// extracted by mini-css-extract-plugin
export default {"select":"select_select__i6sj9","selectError":"select_selectError__iSnvj","label":"select_label__PnEgQ"};